module.exports = __webpack_public_path__ + "static/services-img6-9d7e24a1aa56c5cd01394714bdd5a8b9.png";